import React, { useState } from 'react';
import accountsService from '../../services/accounts';
import styled from 'styled-components';
import { Delete } from '@material-ui/icons';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@material-ui/core';
import { useSnackbar } from 'notistack';

interface Props {
  enabled: boolean;
  id: string;
  onDeleted: () => void;
}

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

interface ButtonProps {
  selected: boolean;
}

const Icon = styled.div<ButtonProps>`
  width: 24px;
  height: 24px;
  color: ${(props) => (props.selected ? '#707070' : '#F7F7F7')};
`;

const DeleteAccount: React.FunctionComponent<Props> = (props) => {
  const [open, setOpen] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const onClick = (event: React.MouseEvent) => {
    if (props.enabled) {
      event.preventDefault();
      event.stopPropagation();
      setOpen(true);
    }
  };
  const onDelete = (event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    if (props.enabled) {
      accountsService.deleteAccount(props.id).then(
        () => {
          enqueueSnackbar('Account ' + props.id + ' has been deleted', {
            variant: 'info',
            autoHideDuration: 3000,
          });
          props.onDeleted();
        },
        () =>
          enqueueSnackbar('Failed to delete account ' + props.id, {
            variant: 'error',
            autoHideDuration: 3000,
          })
      );
    }
    setOpen(false);
  };

  const handleClose = (event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    setOpen(false);
  };

  return (
    <Container>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">{'Delete account?'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Do you want to delete the account '{props.id}'?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            No
          </Button>
          <Button onClick={onDelete} color="primary" autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <Icon selected={props.enabled} onClick={onClick}>
        <Delete style={{ width: '100%', height: '100%' }} />
      </Icon>
    </Container>
  );
};

export default DeleteAccount;
